import { BK_SEPARATOR } from '@/api/hco/constants';
import { getCountryCode } from '@/models';

export enum CountryCode {
  GERMANY = 'DE',
  RUSSIA = 'RU',
}

export function isBkFromCountry(bk: string | undefined | null, country: CountryCode): boolean {
  if (!bk || !bk.includes(BK_SEPARATOR)) return false;
  return getCountryCode(bk) === country;
}
